import { FirmaByPnrResponse } from "../components/wizards/OpretFirma/opretFirmaInterface";
import { useQuery } from "@apollo/client";
import { GET_FIRMA_BY_PNR_QUERY } from "../api/firma/queries";
import { IProduktionsenhed } from "../interfaces/firma";

export function useDuplicateFirmaFinder(
  active: boolean,
  produktionsenhed: IProduktionsenhed | undefined,
): { reason: "p-nummer"; firma: FirmaByPnrResponse } | undefined {
  const { data: firmaByPnrData } = useQuery<{
    firmaer: {
      edges: {
        node: FirmaByPnrResponse;
      }[];
    };
  }>(
    GET_FIRMA_BY_PNR_QUERY({
      pnr: produktionsenhed?.pnummer ?? 0,
    }),
    {
      variables: {
        pnr: produktionsenhed?.pnummer ?? 0,
      },
      skip: !produktionsenhed,
    },
  );

  const existingFirmaByPnr =
    firmaByPnrData && firmaByPnrData.firmaer.edges.length > 0
      ? firmaByPnrData.firmaer.edges.map((edge) => edge.node)[0]
      : undefined;
  if (existingFirmaByPnr && active) {
    return { reason: "p-nummer", firma: existingFirmaByPnr };
  }
  return undefined;
}

export function useDuplicateFirmaByPnrFinder(pnr: number | undefined) {
  const { data, loading } = useQuery<{
    firmaer: {
      edges: {
        node: FirmaByPnrResponse;
      }[];
    };
  }>(
    GET_FIRMA_BY_PNR_QUERY({
      pnr: pnr ?? 0,
    }),
    {
      variables: {
        pnr,
      },
      skip: !pnr,
    },
  );

  const existingFirmaByPnr =
    data && data.firmaer.edges.length > 0
      ? data.firmaer.edges.map((edge) => edge.node)[0]
      : undefined;

  return { existingFirmaByPnr, loading };
}
